import { FiltroFuncionarioModel } from '@/models/filtros/filtro-funcionario.model';
import api from '@/services/axios/api';
import { AxiosResponse } from 'axios';
import { DataSource, FiltrosModel } from '@/datasources/consulte-grid';
import { eTipoPesquisaFiltroFuncionarios } from "@/enums/eTipoPesquisaFiltroFuncionarios";
import { useStore } from "@/store"


class FiltroFuncionarioService {
  codigoEscola: string | null = '';
  codigoTurno: string | null = '';
  ano: string | null = '';

  constructor() {
    this.initialize();
  }

  initialize() {
    this.codigoEscola = useStore().getters.getCodigoEscola;
    this.ano = useStore().getters.getAno;
  }

  dadosIndexPaginado(pagina: number, itensPorPagina: number, filters: FiltrosModel[], eTipoPesquisaFiltroFuncionarios: eTipoPesquisaFiltroFuncionarios, sortDataField?: string): Promise<AxiosResponse<DataSource<FiltroFuncionarioModel>>> {
    this.initialize();
    return api.post<DataSource<FiltroFuncionarioModel>>(`/Funcionario/RetornoPaginado/${this.codigoEscola}/${this.ano}/${eTipoPesquisaFiltroFuncionarios}`, {
      rowsPerPage: itensPorPagina,
      pageNumber: pagina,
      filters: filters,
      sortDataField: sortDataField
    });
  }
}
export default new FiltroFuncionarioService();